// بيانات وهمية لمخبز درة الشام

export const bakeryInfo = {
  name: "Dura Alsham",
  nameAr: "أفران درة الشام في ألمانيا",
  tagline: "أصالة المخبوزات الشامية",
  description: "نقدم لكم أشهى أنواع الخبز العربي والمعجنات الشرقية بأيدي خبراء من بلاد الشام",
  address: "Daimlerstrasse 27/1, 70825 Korntal-Münchingen, Germany",
  addressAr: "كورنتال-مونشينغن، ألمانيا",
  phone: "+49 155 60665588",
  email: "Dura.alsham@outlook.de",
  website: "www.duraalsham.de",
  hours: "يومياً من 12 صباحاً - 10 مساءً",
  logo: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/wd2f7z5r_da6039f4-7955-452d-87cf-38e2a00fc7a1.png"
};

export const products = [
  {
    id: 1,
    name: "خبز الصاج",
    description: "خبز رقيق طازج على الصاج الحار",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/xzs9d3br_f88d740c85d60403a77dea820ebe7ed3_w750_h750.jpg"
  },
  {
    id: 2,
    name: "خبز التنور",
    description: "خبز عربي أصيل من التنور الحجري",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/9i12sos9_maxresdefault.jpg"
  },
  {
    id: 3,
    name: "معجنات شامية",
    description: "فطائر وسمبوسك بحشوات متنوعة",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/2jqqw2k8_DAAGHNoXUAED95I.jpg"
  },
  {
    id: 4,
    name: "حلويات شرقية",
    description: "بقلاوة ومعمول وكنافة طازجة",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/61hzgie8_5c371cad-804e-4fa9-8de8-1baf0b11e42f.jpg",
    comingSoon: true
  },
  {
    id: 5,
    name: "الكروصان والصمون",
    description: "كروصان طازج وصمون يومي",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/n8jsuo72_0b8bab15-e4d5-421f-bbce-1a6d029fd08e.jpg"
  },
  {
    id: 6,
    name: "الخبز التركي",
    description: "خبز البيدا التركي والصمون التركي",
    image: "https://customer-assets.emergentagent.com/job_bread-hub/artifacts/0k2bg8xk_Bread.jpg",
    comingSoon: true
  }
];

export const features = [
  {
    id: 1,
    title: "مكونات طازجة",
    description: "نستخدم أجود أنواع الطحين والمكونات الطازجة يومياً"
  },
  {
    id: 2,
    title: "وصفات أصيلة",
    description: "وصفات شامية متوارثة عبر الأجيال"
  },
  {
    id: 3,
    title: "خبرة طويلة",
    description: "لأعوام في صناعة الخبز التقليدي"
  }
];